'use strict'

document.addEventListener('DOMContentLoaded', function() {
  // 全てのドロップダウンに対してイベントリスナーを設定
  document.querySelectorAll('.dropdown-toggle').forEach(function(dropdownToggle) {
    var dropdownMenu = dropdownToggle.nextElementSibling;
    var hiddenInput = dropdownToggle.previousElementSibling; // hidden input

    // ドロップダウンを開く/閉じる
    dropdownToggle.addEventListener('click', function(event) {
      event.stopPropagation(); // クリックが他の要素にバブリングするのを防ぐ

      // 他のドロップダウンを閉じる
      document.querySelectorAll('.dropdown-menu').forEach(function(menu) {
        if (menu !== dropdownMenu) {
          menu.classList.remove('show');
        }
      });

      // メニューが開いている場合
      if (dropdownMenu.classList.contains('show')) {
        dropdownMenu.classList.remove('show');
      } else {
        dropdownMenu.classList.add('show');
      }
    });

    // オプションのクリック時にボタンに選択したテキストを反映し、hidden inputに値をセット
    dropdownMenu.querySelectorAll('.dropdown-item').forEach(function(item) {
      item.addEventListener('click', function(event) {
        var selectedValue = item.getAttribute('data-value'); // data-value 属性から値を取得
        var selectedText = item.textContent; // 選択肢のテキストを取得

        // ボタンのテキストを選択された項目に変更
        dropdownToggle.textContent = selectedText;

        // 隠しフィールドに値をセット
        hiddenInput.value = selectedValue;

        // ドロップダウンを閉じる
        dropdownMenu.classList.remove('show');
      });
    });

    // ドロップダウン外をクリックすると閉じる
    document.addEventListener('click', function(event) {
      if (!dropdownToggle.contains(event.target) && !dropdownMenu.contains(event.target)) {
        dropdownMenu.classList.remove('show');
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // ToucEvent
  let target = document.getElementById("footer_navbar")
  let postDetail = document.getElementById("post_detail")

  let startX
  let startY
  let moveX
  let moveY
  let dist = 30
  if(target) {
    target.addEventListener('touchstart', function(e) {
      startX = e.touches[0].pageX
      startY = e.touches[0].pageY
    })
    target.addEventListener('touchmove', function(e) {
      e.preventDefault()
      moveX = e.changedTouches[0].pageX
      moveY = e.changedTouches[0].pageY
    })
    target.addEventListener('touchend', function(e) {
      var index
      if(moveX == undefined || moveX == 0){
        // スワイプなし時の処理
      }
      else if (startX > moveX && startX > moveX + dist) {
        // 右から左にスワイプした時の処理
        if(postDetail) {
          Post.next()
        }
      }
      else if (startX < moveX && startX + dist < moveX) {
        // 左から右にスワイプした時の処理
        if(postDetail) {
          Post.prev()
        }
      }
      else {
      }

      startX = 0
      startY = 0
      moveX = 0
      moveY = 0
    })
  }
})
var Post = {
  isAdmin: function(){
    var result = false
    var admin_role_id = 2
    if (document.getElementById("current_login_user_role")) {
      currentLoginUserRole = document.getElementById("current_login_user_role").value
      if(currentLoginUserRole) {
        result = (currentLoginUserRole <= admin_role_id)
      }
    }
    return result
  },
  init: function(){
    serviceBaseUrl = location.origin
    postUrl = serviceBaseUrl + "/front/posts.json"
    postSearchUrl = serviceBaseUrl + "/front/posts/search.json"
    postsKey = "posts"
    postKey = "post"
    if (document.getElementsByName("authenticity_token")) {
      authenticityToken = document.getElementsByName("authenticity_token")[0].value
    }
    if (document.getElementById("current_login_user_id")) {
      currentLoginUserId = document.getElementById("current_login_user_id").value
    }
    if (document.getElementById("managing_post_id")) {
      managingDepartmentId = document.getElementById("managing_post_id").value
    }
  },
  createRequest: function(url, method, data){
    var request = new Request(url, {
      method: method,
      mode: 'cors',
      credentials: 'same-origin',
      headers: new Headers({
        "Content-Type": "application/json",
      }),
      body: data,
      cache: 'no-cache'
    })
    return request
  },
  show: function(info) {
    this.init()
  },
  prev: function() {
    location.href = location.pathname + "/prev"
  },
  next: function() {
    location.href = location.pathname + "/next"
  },
  setMessage: function(messageText) {
    console
    if(flash_messages){
      flash_messages.innerHTML = ""
      var div = document.createElement("div")
      div.setAttribute("class", "alert alert-danger alert-dismissable flash-message")
      div.innerText = messageText
      var button = document.createElement("button")
      button.setAttribute("type", "button")
      button.setAttribute("class", "close")
      button.setAttribute("data-dismiss", "alert")
      button.setAttribute("aria-hidden", "true")
      button.innerText = "x"
      div.appendChild(button)
      flash_messages.appendChild(div)
    }
  },
  create: function(ele) {
    // var modelName = "post"
    // var postUrl = location.origin + "/front/posts.json"
    // var form = document.forms["new_post"]
    // var formData = new FormData(form)

    // var params = {}
    // var data = {}
    // for(var pair of formData.entries()) {
    //   if (pair[0].includes("[")) {
    //     var key = pair[0].substring(pair[0].indexOf("[") + 1, pair[0].length -1)
    //     data[key] = pair[1]
    //   }
    //   else {
    //     params[pair[0]] = pair[1]
    //   }
    // }
    // if(Object.keys(data).length > 0)
    // {
    //   params[modelName] = data
    // }

    // var bodyParam = JSON.stringify(params)
    // var request = this.createRequest(postUrl, "POST", bodyParam)
    // fetch(request)
    //   .then(response => {
    //     if(response.status == 200)
    //     {
    //       json = response.json()
    //     }else{
    //       this.setMessage("イベントの登録に失敗しました。")
    //     }
    //   })
  },
  update: function(info) {
    // var _post
    // var _postUpdateUrl

    // if(_post){
    //   _postUpdateUrl = postUrl.replace(".json", "/" + String(_post.id) + ".json")
    // }
    // var data = JSON.stringify({
    //   "authenticity_token": authenticity_token,
    //   "post": {
    //     "start_at": info.post.start.toISOString(),
    //     "end_at": info.post.end.toISOString(),
    //     "location": info.post.extendedProps.location
    //   }
    // })
    // var request = this.createRequest(_postUpdateUrl, "PUT", data)
    // fetch(request)
    //   .then(response => {
    //     if(response.status == 200)
    //     {
    //       var json = response.json()
    //       this.updateEvent(json)
    //     }else{
    //       this.setMessage("イベントの更新に失敗しました。")
    //       info.revert();
    //     }
    //   })
  },
}
